export default __webpack_public_path__ + "static/media/Clan Bound Legguards of the Clans.11e4622b.jpg";